import type { ReactNode } from 'react';
import ThemeToggle from './ThemeToggle';

type Props = {
  title: string;
  children: ReactNode;
};

export default function AuthLayout({ title, children }: Props) {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-6">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="w-full max-w-sm rounded-lg border bg-card p-6">
        <h1 className="text-2xl font-semibold mb-4">{title}</h1>
        {children}
      </div>
    </div>
  );
}
